import { FC } from "react";
import { DateTime } from "luxon";
import { Text } from "@mantine/core";
import { localTimeDiffers } from "../layout/applicationTimeZone.ts";

interface TimeZoneHintProps {
  dateTime: DateTime | string;
}

/**
 * Benennt die Zeitzone, in der die Uhrzeit daneben angezeigt wird — aber nur
 * dann, wenn die Uhr des Bewerbers anders geht als die deutsche. Wer in
 * Deutschland sitzt, sieht keinen Zusatz.
 */
export const TimeZoneHint: FC<TimeZoneHintProps> = (props) => {
  const dateTime =
    typeof props.dateTime == "string"
      ? DateTime.fromISO(props.dateTime)
      : props.dateTime;

  if (!localTimeDiffers(dateTime)) {
    return null;
  }

  return (
    <Text span size="sm" c="dimmed">
      {" "}
      ({dateTime.toLocal().setLocale("de").toFormat("ZZZZ")})
    </Text>
  );
};
